import {
  Button as ButtonMui,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { Fragment, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import QrReader from "react-qr-reader";
import styled from "styled-components";
import {
  checkUserAccessAndToken,
  getHeaderForAxios,
  getUserData,
} from "../../common/getLocalStorageData";
import {
  ADMIN_USER_ACCESS,
  NORMAL_USER_ACCESS,
  STORE_USER_ACCESS,
} from "../../constant/FrontEnd";
import axios from "axios";
import AnimatedCheckmark, { MODES } from "react-animated-checkmark";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import {
  PROFILE_STORE_DEALLIST,
  SIDE_MENU_PROFILE,
} from "../../constant/menuAndProfile";

const QrReaderWrapper = styled.div`
  width: 100%;
`;

interface IDealLcdList {
  dealDetail: Array<any>;
  selectedDeal: any;
  lcdList: Array<any>;
  selectedSponsor: string;
  refreshData?: () => void;
  openSelectOption: (open: boolean) => void;
}
interface IData {
  index?: number;
  user?: string;
  match_title?: string;
  tp_name?: string;
  store_name?: string;
  is_winner?: number;
  is_redeemed?: number;
  sell_winner_nothing?: number;
  is_active_comp?: boolean;
}

export const DealLcdList = (props: IDealLcdList) => {
  const [results, setResults] = useState<IData[]>([]);
  const [finalData, setFinalData] = useState<(string | number | undefined)[][]>(
    []
  );
  const [currentDealDetail, setCurrentDealDetail] = useState<any>({});
  const [changeFlag, setFlag] = useState<boolean>(true);
  const [openSellLcdDialog, setOpenSellLcdDialog] = useState<boolean>(false);
  const [mode, setMode] = useState(MODES.LOADING);
  const [toggleFlag, setToggleFlag] = useState<boolean>(false);
  const [allowedCamera, setAllowedCamera] = useState<boolean>(false);
  const [lcdSellSuccessfull, setLcdSellSuccessfull] = useState<boolean>(false);
  const [lcdSellResponse, setLcdSellResponse] = useState({
    type: "",
    message: "",
  });

  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLanguage = globalState?.selectedLang;

  const columns = [
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].no,
      options: { filter: false, fullWidth: true },
    },
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].user,
      options: { filter: false },
    },
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].match,
      options: { filter: true },
    },
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].team_player,
      options: { filter: true },
    },
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].sell_by,
      options: { filter: true },
    },
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].winner,
      options: {
        filter: true,
        customBodyRender: (value: any) => (
          <Fragment>{value ? <FaCheck /> : <FaTimes />}</Fragment>
        ),
      },
    },
    {
      name: PROFILE_STORE_DEALLIST[selectedLanguage].redeem,
      options: {
        filter: true,
        customBodyRender: (value: any) => (
          <Fragment>{value ? <FaCheck /> : <FaTimes />}</Fragment>
        ),
      },
    },
  ];

  const options: MUIDataTableOptions = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    jumpToPage: true,
    fixedSelectColumn: false,
    fixedHeader: false,
    pagination: true,
    selectableRows: "none",
    rowsPerPageOptions: [100, 200, 300, 400],
    rowsPerPage: 100,
    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
    },
  };

  const userId = getUserData();
  const storeUser = checkUserAccessAndToken(STORE_USER_ACCESS);
  const normalUser = checkUserAccessAndToken(NORMAL_USER_ACCESS);
  const adminUser = checkUserAccessAndToken(ADMIN_USER_ACCESS);

  const handleScan = (data: any) => {
    const dataArray = data ? data.split("/") : [];
    if (dataArray.length && dataArray.length === 5) {
      if (adminUser) {
        alert("Your admin you can't access scan lcd route");
      } else if (storeUser || normalUser) {
        let payload: any = {
          user_uuid: userId,
          lcd_identifier: dataArray[4],
          is_store: storeUser ? 1 : 0,
        };

        axios
          .post(process.env.REACT_APP_API_URL + "/user/lcdScan", payload, {
            headers: getHeaderForAxios(),
          })
          .then((response) => {
            if (response?.data?.status) {
              setLcdSellSuccessfull(true);
              setLcdSellResponse({
                type: "success",
                message: response?.data?.message,
              });
              setTimeout(() => setMode(MODES.SUCCESS), 1500);
              setTimeout(() => {
                setMode(MODES.LOADING);
                setOpenSellLcdDialog(false);
                setLcdSellSuccessfull(false);
                setToggleFlag(!toggleFlag);
                setLcdSellResponse({ type: "", message: "" });
              }, 3000);
            }
          })
          .catch((error) => {
            const message = error.response?.data?.message || "Scan failed";
            setLcdSellResponse({ type: "error", message });
            setTimeout(() => {
              setLcdSellResponse({ type: "", message: "" });
            }, 3000);
          });
      }
    }
  };

  const handleError = (err: any) => {
    console.log("handleError >", err);
    setLcdSellResponse({ type: "error", message: err });
    setTimeout(() => {
      setLcdSellResponse({ type: "", message: "" });
    }, 3000);
  };

  const successCallback = () => setAllowedCamera(true);
  const errorCallback = () => setAllowedCamera(false);

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(successCallback, errorCallback);
  }, []);

  useEffect(() => {
    if (props.lcdList) {
      const data = props.lcdList.map((Data: any, index: number) => ({
        index: index + 1,
        user: Data?.user_name,
        match_title: Data?.match_title,
        tp_name: Data?.tp_name,
        store_name: Data?.store_name,
        is_winner: Data?.is_winner,
        is_redeemed: Data?.is_redeemed,
      }));
      setResults(data);
      setFinalData(
        data.map((result) => [
          result.index,
          result.user || "",
          result.match_title || "",
          result.tp_name || "",
          result?.store_name || "NA",
          result?.is_winner || 0,
          result?.is_redeemed || 0,
        ])
      );
    }
  }, [props.lcdList]);

  useEffect(() => {
    if (props?.dealDetail && props?.selectedDeal) {
      props?.dealDetail?.forEach((dData: any) => {
        if (dData?.uuid === props?.selectedDeal) {
          setCurrentDealDetail(dData);
          setFlag(!changeFlag);
        }
      });
    }
  }, [props?.dealDetail, props?.dealDetail.length, props?.selectedDeal]);

  return (
    <Fragment key={changeFlag ? "true" : "false"}>
      <Dialog
        open={openSellLcdDialog}
        onClose={() => setOpenSellLcdDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="d-flex align-self-center justify-content-center">
          {PROFILE_STORE_DEALLIST[selectedLanguage].dialog_scan_lcd}
        </DialogTitle>
        <DialogContent key={toggleFlag ? "true" : "false"}>
          <Row className="mx-5">
            <Col sm={12}>
              {allowedCamera ? (
                <Fragment>
                  {lcdSellResponse.message && (
                    <div
                      className={
                        "text-center mb-1 " +
                        (lcdSellResponse.type === "success"
                          ? "form-response success"
                          : "form-response error")
                      }
                    >
                      {lcdSellResponse.message}
                    </div>
                  )}
                  {openSellLcdDialog && !lcdSellSuccessfull ? (
                    <QrReaderWrapper>
                      <QrReaderWrapper>
                        <QrReader
                          facingMode="environment"
                          onScan={(result) => {
                            if (result) handleScan(result);
                          }}
                          onError={(error) => {
                            if (error)
                              handleError(error.message || "Scan error");
                          }}
                          style={{ width: "100%" }}
                        />
                      </QrReaderWrapper>
                    </QrReaderWrapper>
                  ) : (
                    <div className="w-100 text-center">
                      <AnimatedCheckmark mode={mode} breathingCollapse={true} />
                    </div>
                  )}
                </Fragment>
              ) : (
                <div className="text-center mb-1 form-response error">
                  {PROFILE_STORE_DEALLIST[selectedLanguage].camera_permission}
                </div>
              )}
            </Col>
          </Row>
        </DialogContent>
        <DialogActions>
          <Row className="mx-5 mb-2 w-100 d-flex align-self-center justify-content-center">
            <Button
              onClick={() => setOpenSellLcdDialog(false)}
              variant="primary"
              className="ml-2 py-1 rounded-sm"
              autoFocus
            >
              {SIDE_MENU_PROFILE[selectedLanguage].close}
            </Button>
          </Row>
        </DialogActions>
      </Dialog>
      <div className="right-side-header-main">
        <div className="right-side-header">
          {PROFILE_STORE_DEALLIST[selectedLanguage].card_list}
          <div className="material-dropdown-select header-toggle-button">
            <ButtonMui
              variant="contained"
              className="mr-2 py-1 my-1 rounded-sm"
              //d-none d-md-block
              onClick={() => setOpenSellLcdDialog(true)}
            >
              {PROFILE_STORE_DEALLIST[selectedLanguage].sell_lcd}
            </ButtonMui>
            <Button
              onClick={() => props.openSelectOption(true)}
              variant="primary"
              className="btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16"
              autoFocus
            >
              {PROFILE_STORE_DEALLIST[selectedLanguage].toggle_data}
            </Button>
          </div>
        </div>
      </div>
      <hr />
      <Row className="pt-2">
        <Col sm={12} className="react-table-kitchen-wrapper theme-dark-black">
          <div className="table-wrapper" style={{ flexGrow: 1 }}>
            {finalData && (
              <MUIDataTable
                title={
                  (props?.selectedSponsor
                    ? props?.selectedSponsor + " - "
                    : "") + (currentDealDetail?.match_title || "")
                }
                data={finalData}
                columns={columns}
                options={options}
              />
            )}
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};
